const FUND_DEADLINE_TIME_ZONE = 'America/New_York';
const DATE_PREFIX_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;
const fundDeadlineDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: FUND_DEADLINE_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const getFundDeadlineDateKey = (date) => {
  const dateParts = fundDeadlineDateFormatter.formatToParts(date);
  const year = dateParts.find(({ type }) => type === 'year')?.value;
  const month = dateParts.find(({ type }) => type === 'month')?.value;
  const day = dateParts.find(({ type }) => type === 'day')?.value;

  if (!year || !month || !day) {
    throw new Error('Unable to determine the current fund deadline date');
  }

  return `${year}-${month}-${day}`;
};

const getFinalCloseDateKey = (finalCloseDate) => {
  const match = DATE_PREFIX_PATTERN.exec(finalCloseDate);

  if (!match) {
    throw new TypeError(`Invalid final close date: ${finalCloseDate}`);
  }

  const [, year, month, day] = match;
  const parsedDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  const isValidDate = parsedDate.getUTCFullYear() === Number(year)
    && parsedDate.getUTCMonth() === Number(month) - 1
    && parsedDate.getUTCDate() === Number(day);

  if (!isValidDate) {
    throw new TypeError(`Invalid final close date: ${finalCloseDate}`);
  }

  return `${year}-${month}-${day}`;
};

const isFundOpenThroughFinalClose = (finalCloseDate, now = new Date()) => {
  if (!finalCloseDate) {
    return true;
  }

  return getFinalCloseDateKey(finalCloseDate) >= getFundDeadlineDateKey(now);
};

export default isFundOpenThroughFinalClose;
